import { useMemo, useState } from 'react';
import { addTitleRowsIntoStudents, groupStudentsByTableFilters, } from './tableConfig';
export var useStudentsTableData = function (_a) {
    var students = _a.students;
    var _b = useState(students), currentStudents = _b[0], setCurrentStudents = _b[1];
    var groupedStudents = useMemo(function () { return groupStudentsByTableFilters(currentStudents); }, [currentStudents]);
    var tableData = useMemo(function () { return addTitleRowsIntoStudents(groupedStudents); }, [groupedStudents]);
    return {
        tableData: tableData,
        updateStudents: setCurrentStudents,
        currentStudents: currentStudents,
    };
};
